var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "app-rule" },
    [
      _vm._m(0),
      _c("p", { staticClass: "mat10" }, [_vm._v("自考乐app.apk")]),
      _c(
        "el-button",
        {
          staticClass: "mat50",
          attrs: { type: "primary" },
          on: { click: _vm.getAndroidUrl },
        },
        [_vm._v("安装下载")]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("img", {
        staticClass: "img",
        staticStyle: { width: "100px" },
        attrs: { src: require("@/assets/images/appIcon.png"), alt: "" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }